import { render } from "./App.vue?vue&type=template&id=dd61fdda"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=dd61fdda&lang=css"

import exportComponent from "/Users/alexmeister/Documents/GitHub/inclusion_score/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__